export enum CopyMode {
  FullTransfer = 'FullTransfer',
  Template = 'Template',
}

export interface IComponentsStructureMenu {
  parentId: string;
  name: string;
  id: string;
  type: string;
  children: IComponentsStructureMenu[];
  additionalOptions: string[];
}

export interface CopyComponentsModel {
  targetDepartmentIds: string[];
  targetTenantId: string;
  copyContents: boolean;
  copyMode: CopyMode;
}

export interface ComponentCopyStatus {
  pendingCount: number;
  failedCount: number;
}
